<template>
  <div class="login">
    <div class='container'>
      <div class='row'>
        <div class='col-md-4'>
          <div class="input-group">
              <span class="input-group-text">用户名：</span>
              <input v-model="username" class="form-control"  placeholder="用户名"/>
          </div>
        </div>
        <div class='col-md-4'>
          <div class="input-group">
              <span class="input-group-text">密<span style='margin:0 8px'></span>码：</span>
              <input v-model="password" type="password" class="form-control"  placeholder="密码"/>
          </div>
        </div>
        <div class='col-md-4'>
          <div class="input-group">
              <span class="btn btn-primary form-control"
                    @click='Login'>登录</span>
          </div>
        </div>
        <div class='col-md-12 text-center'>
        <router-link to="/register" >注册账号</router-link>
        <span style='margin:5px'></span>
        <router-link to="/changepsw" >修改密码</router-link>
      </div>
      </div>
      
    </div>
  </div>
</template>

<script>
//import axios from 'axios'

export default {
  name: 'Login',
  data() {
    return {
        username:'',
        password:''
    }
  },
  methods:{
    Login(){
      var that=this;
      if(this.username==''||this.password=='')
      {
        that.$toast('请填写用户名密码','fail')
        return;
      }
      //登录 
      that.$myAxios(that,
        {
          method: 'POST',
          url:'/api/User/Login?username='+that.username+'&password='+that.password,
        }
        ,res=>{
          that.$toast(res.msg,'succ');
          var arr= res.description.split('@');
          that.$cookies.set('username',arr[0]);
          that.$cookies.set('ticket',arr[1]);
          var fUrl = that.$route.query.f;
          if(fUrl&&fUrl!='Home'){
            that.$router.push('/'+fUrl);
          }
          else
          {
            that.$router.push('/');
          }
        }
      )
    }
  },
  computed:{
    
  },
  mounted()
  {
      
  }
}
</script>